import { Snackbar } from "@mui/joy";
import { HTTPError } from "griptonite-api-client/client";
import { create } from "zustand";

const FALLBACK_MESSAGE = "Couldn't save that change. Please try again.";

const useRouteLabelsToast = create<{ message: string | null }>()(() => ({ message: null }));

// The server explains a rejected name (for example a duplicate), so show that
// when there is one.
const getErrorMessage = (error: unknown) => {
  if (!(error instanceof HTTPError)) {
    return FALLBACK_MESSAGE;
  }
  const data = error.jsonData;
  const nameError = (Array.isArray(data) ? data.find((item) => item?.name) : data)?.name;
  const message = Array.isArray(nameError) ? nameError[0] : nameError;
  return typeof message === "string" ? message : FALLBACK_MESSAGE;
};

export const showRouteLabelsError = (error: unknown) =>
  useRouteLabelsToast.setState({ message: getErrorMessage(error) });

export const RouteLabelsToast = () => {
  const message = useRouteLabelsToast((state) => state.message);
  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={message !== null}
      onClose={() => useRouteLabelsToast.setState({ message: null })}
      autoHideDuration={6000}
      color="danger"
      variant="soft"
    >
      {message}
    </Snackbar>
  );
};
